module.exports = __webpack_public_path__ + "media/site_templates/www.carpetcleaning.agency/images/our_services_2-c0410f674cb20ac4823822d05bb38662.jpg";